import React, { useEffect, useState } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import {useFetch} from '../../components/auth/useFetch';

export default function UploadExploreMobile(props) {

    const { fileBrowserRef, filterClips } = props
    const fetchWithAuth = useFetch()

    const onFileSelect = (event) => {
        uploadEDL(event.target.files[0])

    }

    const uploadEDL = async (file) => {
        var formdata = new FormData();
        formdata.append("file_upload", file);
        var requestOptions = {
            method: 'POST',
            body: formdata,
            redirect: 'follow'
        }
        fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/edlclipnames/`, requestOptions)
            .then(response => response.json())
            .then(result => {
                filterClips(result)
            })
    }

    return (
        <input
            type='file'
            id='file'
            ref={fileBrowserRef}
            style={{display: 'none'}}
            onChange={onFileSelect}
        />
    )}